"use client"

import styled from "@emotion/styled"
import { CustomImage } from "ui"
import Container from "ui/Container"
import { sharedColors } from "ui/theme/colors"
import { extractProperty } from "utils"
import { getUmbracoMediaUrl } from "utils/getUmbracoMediaUrl"

const OuterContainer = styled.div<{ $isGray?: boolean }>`
  width: 100%;
  background-color: ${({ $isGray }) =>
    $isGray ? sharedColors.mediumGrayLight : "transparent"};
`

const StyledContainer = styled.div`
  width: 100%;
  padding: 32px 0;
  display: flex;
  justify-content: center;
  ${({ theme }) => theme.breakpoints.up("md")} {
    justify-content: unset;
    padding: 48px 0;
  }
`

type Props = {
  data: any
  blockIndex?: number
  isHomepage?: boolean
}

export default function Logo({ data, blockIndex, isHomepage }: Props) {
  const logo = extractProperty(data, "logo")
  const isGray = isHomepage && typeof blockIndex === "number" && blockIndex % 2 === 1
  return (
    <OuterContainer $isGray={isGray}>
      <Container paddingMobile={true}>
        <StyledContainer>
          <CustomImage
            src={getUmbracoMediaUrl(logo)}
            alt={"אגד"}
            width={222}
            height={80}
          />
        </StyledContainer>
      </Container>
    </OuterContainer>
  )
}
